import { type RovoInstrumentedError } from '../rovo-instrumented-error';

/**
 * Copy of this also exists in `conversation-assistant-service/src/common/utils/fetch-error.ts`
 */
export class FetchError extends Error implements RovoInstrumentedError {
	constructor(
		message: string,
		public errorAttributes: {
			statusCode?: number;
			traceId?: string;
			requestId?: string;
			rawErrorMessage?: string;
			errorCode?: string;
		},
	) {
		super(message);
		this.name = 'FetchError';
	}
}
